import { ChooseCountryPage } from "@nju/feature-portal-additional-packages";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../../../components/ClientSideRenderer";

export default function ChooseInternationalCallsOffer() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="default">
        <ClientSideOnly>
          <ChooseCountryPage />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
